import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Spin, PageHeader, Space, Modal, AutoComplete, Select } from "antd";
import queryString from "query-string";
import { MoreOutlined } from "@ant-design/icons";
import _ from "lodash";

import { Table } from "../../components";
import {
  Container,
  TableContainer,
  TableButtonsContainer,
  SpaceBetween,
} from "./styles";
import { columns } from "./helpers";
import { helpers } from "../../utils";
import { getUrl, requests } from "../../globals/requests";
import { Pagination } from "../../components";

const { Option } = AutoComplete;

const buffData = {};
const buffTotal = {};
const buffSearch = {};

function Users(props) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [results, setResults] = useState([]);
  const [searchVal, setSearch] = useState("");
  const [searchKey, setSearchKey] = useState("name");
  const [page, setPage] = useState(1);
  const limit = 10;

  const history = useHistory();

  columns[columns.length - 1].render = (user) => (
    <MoreOutlined
      style={{ fontSize: "20px" }}
      onClick={() => moreOptions(user._id)}
    />
  );

  function moreOptions(userId) {
    history.push(`/dashboard/users/${userId}`);
  }

  function onPaginationChange(current, limit) {
    setPage(current);
    getUsers({ page: current, limit });
  }

  const getUsers = useCallback(async (params) => {
    try {
      const queryObj = queryString.parse(window.location.search);
      const query = { ...queryObj, ...params };
      const key = JSON.stringify(query);

      if (buffTotal[key] && buffData[key]) {
        setUsers(buffData[key]);
        setTotalPages(buffTotal[key]);
      }
      const url = getUrl("users");
      //setLoading(true);
      const response = await requests.getWithAuth(url, query);
      const { data, total } = response.data;
      setUsers(data);
      setLoading(false);
      setTotalPages(total);
      if (!buffData[key]) {
        buffData[key] = data;
      }
      if (!buffTotal[key]) {
        buffTotal[key] = total;
      }
    } catch (e) {
      helpers.displayMessage(e);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getUsers({ page, limit });
  }, []);

  const searchUsers = async (searchKey, searchText) => {
    try {
      if (buffSearch[searchText]) {
        setResults(buffSearch[searchText]);
        return;
      }
      const response = await requests.getWithAuth(
        `${getUrl("users")}/search?${searchKey}=${searchText}`
      );
      setResults(response.data.data);
      buffSearch[searchText] = response.data.data;
      console.log("callede");
    } catch (e) {
      helpers.displayMessage(e);
    }
  };

  const getUsersDebounce = useCallback(
    (searchVal) => {
      _.debounce(searchUsers, 1000, { trailing: true })(searchKey, searchVal);
    },
    [searchKey]
  );

  const getUsersThrottle = useCallback(
    (searchVal) => {
      _.throttle(searchUsers, 1000, { trailing: true })(searchKey, searchVal);
    },
    [searchKey]
  );

  const handleTextChange = useCallback(
    (text) => {
      setSearch(text);
      if (text.length < 3) {
        return;
      }
      if (text.length < 7) {
        getUsersDebounce(text);
      } else {
        getUsersThrottle(text);
      }
    },
    [getUsersDebounce, getUsersThrottle]
  );
  const handleSearchKeyChange = (searchKey) => {
    setSearchKey(searchKey);
    getUsersDebounce(searchKey, searchVal);
  };

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Users..."></Spin>
      </div>
    );
  }
  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Users"
      />

      <Space direction="vertical" size="large">
        <TableButtonsContainer>
          <SpaceBetween>
            <div className="org-inpup-container">
              <AutoComplete
                // value={search}
                style={{ width: 200 }}
                onSelect={moreOptions}
                onSearch={handleTextChange}
                placeholder={`Search by ${searchKey}`}
              >
                {results.map((res) => {
                  const displayVal = res[searchKey];
                  if (searchKey === "name") {
                    return (
                      <Option key={res._id} value={res._id}>
                        {res.first_name}&nbsp;{res.last_name}
                      </Option>
                    );
                  }
                  return (
                    <Option key={res._id} value={res._id}>
                      {displayVal}
                    </Option>
                  );
                })}
              </AutoComplete>
              <Select
                value={searchKey}
                style={{ width: 120 }}
                onChange={handleSearchKeyChange}
              >
                <Option value="name">Name</Option>
                <Option value="email">Email</Option>
              </Select>
            </div>
          </SpaceBetween>
        </TableButtonsContainer>
        <TableContainer>
          <Table pagination={false} columns={columns} dataSource={users} />
        </TableContainer>
        {!!totalPages && (
          <Pagination
            position="left"
            current={page}
            limit={limit}
            total={totalPages}
            showSizeChanger
            onChange={onPaginationChange}
          />
        )}
      </Space>
    </Container>
  );
}

export default Users;
